export default __webpack_public_path__ + "static/media/request_prize-stap_04.c03f3df8.png";